const e = { "logged-ticket-private": "{{name}}님이 이것을 기록했습니다", view: "보기", "view-ticket": "티켓 보기", meeting: "미팅", "shared-private": "{{name}}님이 이것을 공유했습니다", "logged-ticket-public": "{{name}}님이 이것을 기록했습니다", "shared-public": "{{name}}님이 이것을 기록했습니다", "crated-meeting-public": "{{name}}님이 미팅을 공유했습니다", "crated-meeting-private": "{{name}}님이 미팅을 만들었습니다" }, t = { ticketing: "티켓 발급", messaging: "메시징" }, i = {
  link: e,
  category: t
};
export {
  t as category,
  i as default,
  e as link
};
